// extracted by mini-css-extract-plugin
export var grid = "_1q-0";
export var span1 = "_1q-2";
export var span10 = "_1q-b";
export var span10L = "_1q-z";
export var span10M = "_1q-n";
export var span10Xl = "_1q-1b";
export var span11 = "_1q-c";
export var span11L = "_1q-10";
export var span11M = "_1q-o";
export var span11Xl = "_1q-1c";
export var span12 = "_1q-d";
export var span12L = "_1q-11";
export var span12M = "_1q-p";
export var span12Xl = "_1q-1d";
export var span1L = "_1q-q";
export var span1M = "_1q-e";
export var span1Xl = "_1q-12";
export var span2 = "_1q-3";
export var span2L = "_1q-r";
export var span2M = "_1q-f";
export var span2Xl = "_1q-13";
export var span3 = "_1q-4";
export var span3L = "_1q-s";
export var span3M = "_1q-g";
export var span3Xl = "_1q-14";
export var span4 = "_1q-5";
export var span4L = "_1q-t";
export var span4M = "_1q-h";
export var span4Xl = "_1q-15";
export var span5 = "_1q-6";
export var span5L = "_1q-u";
export var span5M = "_1q-i";
export var span5Xl = "_1q-16";
export var span6 = "_1q-7";
export var span6L = "_1q-v";
export var span6M = "_1q-j";
export var span6Xl = "_1q-17";
export var span7 = "_1q-8";
export var span7L = "_1q-w";
export var span7M = "_1q-k";
export var span7Xl = "_1q-18";
export var span8 = "_1q-9";
export var span8L = "_1q-x";
export var span8M = "_1q-l";
export var span8Xl = "_1q-19";
export var span9 = "_1q-a";
export var span9L = "_1q-y";
export var span9M = "_1q-m";
export var span9Xl = "_1q-1a";
export var stretch = "_1q-1";